/* eslint-disable lines-between-class-members */
/* eslint-disable import/prefer-default-export */
export class FooterConstants {
  static TELEFONO_ATENCION_CLIENTE = '944 943 444' as string;

  // links bloque siguenos
  static URL_FACEBOOK_EROSKI = 'https://www.facebook.com/Eroski' as string;
  static URL_TWITTER_EROSKI = 'https://twitter.com/eroski' as string;
  static URL_YOUTUBE_EROSKI = 'https://www.youtube.com/user/eroski' as string;
  static URL_INSTAGRAM_EROSKI = 'https://www.instagram.com/eroskioficial' as string;

  // links bloque eroski
  static URL_CORPORATIVO = 'https://corporativo.eroski.es/' as string;
  static URL_MEMORIA = 'https://memoria.eroski.es/' as string;
  static URL_SALA_DE_PRENSA = 'http://www.eroskicorporativo.es' as string;

  // links bloque tiendas eroski
  static URL_DESCANSO_INICIO = 'https://preproducciondescanso.eroski.es/descanso/' as string;
  static URL_DESCANSO_FINAL = '/categorias' as string;
  static URL_ELECTROHOGAR = 'https://preproduccionelectrohogar.eroski.es/electroventa/' as string;
  static URL_SEGUROS_INICIO = 'https://www.eroskiasegura.es/' as string;
  static URL_SEGUROS_FINAL = '/inicio' as string;
  static URL_VIAJES = 'http://www.viajeseroski.es/' as string;

  // links boque confianza
  static URL_CONFIANZA = 'https://www.confianzaonline.es/empresas/grupoeroski.htm' as string;
  static URL_ADIGITAL = 'https://www.adigital.org/asociados/eroski/' as string;

  // links bloque descargas de app
  static URL_GOOGLE_PLAY = 'https://play.google.com/store/search?q=eroski' as string;
  static URL_APP_STORE = 'https://itunes.apple.com/us/app/apple-store/id1071407778?mt=8' as string;

  // links bloque caprabo
  static URL_ELIGE_BUENO_ELIGE_SANO = 'https://www.triabotriasa.es/' as string;
  static URL_MICRODONACIONESCAPRABO = 'https://www.microdonacionscaprabo.cat/' as string;
  static URL_SOSTENIBILITATCAPRABO = 'https://www.sostenibilitatcaprabo.cat/' as string;
  static URL_FRANQUICIAS = 'https://franquicias.caprabo.com/' as string;

  // links bloque siguenos CAPRABO
  static URL_FACEBOOK_CAPRABO = 'https://www.facebook.com/Caprabo' as string;
  static URL_TWITTER_CAPRABO = 'https://twitter.com/caprabo' as string;
  static URL_YOUTUBE_CAPRABO = 'https://www.youtube.com/user/Caprabo50' as string;
  static URL_INSTAGRAM_CAPRABO = 'https://www.instagram.com/caprabo_supermercats' as string;
  static URL_FLICKR_CAPRABO = 'https://www.flickr.com/photos/caprabo' as string;
}
